// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__D7Cd9","links":"styles_links__21dbQ","active":"styles_active__1MZB4"};